import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Card, CardBody, Row, Col, CardTitle, CardText, CardSubtitle, Button } from 'reactstrap';
import Moment from 'react-moment';
import { FaBell } from "react-icons/fa";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications, jobStatus, selectChangeOfEquipment, selectInstallationBossUnit, selectInstallationTimeLapse, selectInstallationXseries, selectRelocationData, selectRemovalOrder, selectServicesData, showSelectedInstallationType } from 'store/job/actions';
import createCustomerSelector from 'store/customer/selector';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import socket from 'socket/socket';

const NotificationModal = ({ notifications, toggle, recieverId }) => {
    const dispatch = useDispatch();

    const handleClearNotifications = async (recieverId) => {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/job/notifications-clear/${recieverId}`);
        if (response.status === 200) {
            socket.emit('notification:new', { isNewNotificaton: true });
            dispatch(fetchNotifications(true));
        }
    }

    const sortedNotifications = [...notifications].sort((a, b) => {
        return new Date(b.timestamp) - new Date(a.timestamp);
    });

    return (
        <Modal isOpen={true} toggle={toggle}>
            <ModalHeader toggle={toggle}>Notifications</ModalHeader>
            <ModalBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {sortedNotifications.length > 0 ? sortedNotifications.map((notification) => (
                    <NotificationCard key={notification.id} notification={notification} toggle={toggle} />
                )) : <NotNotificationCard />}
                {sortedNotifications.length > 0 &&
                    <div className='d-flex justify-content-end'>
                        <Button color="link" className='text-danger' onClick={() => handleClearNotifications(recieverId)}>
                            Clear All
                        </Button>
                    </div>
                }
            </ModalBody>
        </Modal>
    );
};

const NotificationCard = ({ notification, toggle }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const customerSelector = useSelector(createCustomerSelector);
    const { allCustomersData } = customerSelector || {};
    const [customerName, setCustomerName] = useState('N/A');

    useEffect(() => {
        const customer = allCustomersData?.find((val) => val._id === notification.customer_id);
        if (customer) {
            setCustomerName(customer.name);
        }
    }, [notification.customer_id, allCustomersData]);

    const handleSelectEvent = async (event) => {
        dispatch(jobStatus(event.status));
        const jobType =
            event.jobType === "BossUnit"
                ? "InstallationBossUnit"
                : event.jobType === "Timelapse"
                    ? "InstallationTimeLapse"
                    : event.jobType === "COE"
                        ? "ChangeOfEquipment"
                        : event.jobType === "Xseries"
                            ? "InstallationXseries"
                            : event.jobType;

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/job/select-request`,
                {
                    jobId: event.jobId,
                    jobType: jobType,
                }
            );

            if (response.status === 200) {
                const dispatchAndNavigate = (dispatchAction, path) => {
                    dispatch(dispatchAction(response.data));
                    history.push(path, {
                        jobId: event.jobId,
                        jobType: jobType,
                        find_job_number: event.find_job_number,
                        isCOE: path === "change-of-equipment" ? true : false,
                    });
                    toggle();
                };

                switch (jobType) {
                    case "InstallationXseries":
                        dispatch(showSelectedInstallationType(1));
                        return dispatchAndNavigate(
                            selectInstallationXseries,
                            "new-installation"
                        );
                    case "InstallationBossUnit":
                        dispatch(showSelectedInstallationType(2));
                        return dispatchAndNavigate(
                            selectInstallationBossUnit,
                            "new-installation"
                        );
                    case "InstallationTimeLapse":
                        dispatch(showSelectedInstallationType(3));
                        return dispatchAndNavigate(
                            selectInstallationTimeLapse,
                            "new-installation"
                        );
                    case "RemovalOrder":
                        return dispatchAndNavigate(selectRemovalOrder, "new-removal");
                    case "Relocation":
                        return dispatchAndNavigate(selectRelocationData, "new-relocation");
                    case "ChangeOfEquipment":
                        return dispatchAndNavigate(
                            selectChangeOfEquipment,
                            "change-of-equipment"
                        );
                    case "Services":
                        dispatch(selectServicesData(response.data));
                        return history.push(`services`, {
                            jobId: event.jobId,
                            jobType: event.jobType,
                        });
                    default:
                        break;
                }
            }
        } catch (error) {
            console.error("Error handling select event:", error);
        }
    };


    return (
        <Card className="custom-notification-card mb-2">
            <CardBody>
                <Row>
                    <Col xs="8">
                        <CardTitle tag="h6" className="mb-2 text-primary">
                            {notification.jobType === 'RemovalOrder' ? 'Removal Order' : notification.jobType}
                        </CardTitle>
                        <strong>Customer: </strong>  <span style={{ color: 'black', textTransform: 'capitalize' }}> {`${customerName}`}</span>
                        <CardText className="mb-0" style={{ fontSize: '13px' }}>
                            {notification.text}
                        </CardText>
                        <CardText>
                            <div className="text-muted">
                                <strong>Job Number: </strong>
                                <Button color='link' className='p-0 m-0' onClick={() => handleSelectEvent(notification)}>{notification.jobId}</Button>
                            </div>
                            <div>
                                <span className='p-0 m-0' style={{ fontSize: '12px' }}>
                                    {notification?.site_address || 'N/A'}
                                </span>
                            </div>
                        </CardText>
                    </Col>
                    <Col xs="4">
                        <CardSubtitle className="text-muted mb-2" tag="h6" style={{ textAlign: 'right' }}>
                            <Moment fromNow>{notification.timestamp}</Moment>
                        </CardSubtitle>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

const NotNotificationCard = () => {
    return (
        <CardBody>
            <Row>
                <Col xs="4"></Col>
                <Col xs="4">
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <FaBell fontSize={40} color='#dee2e6' />
                        <CardText className='mt-3'>No Notifications</CardText>
                    </div>
                </Col>
                <Col xs="4"></Col>
            </Row>
        </CardBody>
    );
};

export default NotificationModal;
